import { useState, useEffect, useRef, useMemo } from "react";
import "./LiveSessionDeatail.css";
import axios from "../../../axios";
import { DatePickerComponent, Inject } from "@syncfusion/ej2-react-calendars";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  Button,
} from "@mui/material";

import {
  Day,
  Resize,
  ScheduleComponent,
  ViewDirective,
  ViewsDirective,
  Week,
} from "@syncfusion/ej2-react-schedule";
import { getTimeTable } from "../../../DCM/services/time-table-service";
import TimeTableDayEvent from "../../../DCM/components/day-event/Time-table-day-event";
import TimeTableWeekEvent from "../../../DCM/components/week-event/Time-table-week-event";
import { useNavigate } from "react-router-dom";
import { endOfWeek, startOfWeek } from "date-fns";
import SummaryLectureUi from "./SubjectDatailsCM/summaryLectureUi";
import { SubStdSelContext } from "../../../SubStdSelContext";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"; // calendar icon
import ListOfTeachersPop from "../../../DCM/components/day-event/ListOfTeachersPop";

let startday1;
let endday1;
let start_time1;
let end_time1;
let date;
export default function LiveSessionDeatail({ leftSidebarSize }) {
  let response6 = [];
  let response1 = [];
  var response2 = [];
  const helper4 = (item) => {
    return Object.entries(item).map(([name, value]) => ({ name, value }));
  };
  const academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  let timetableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  const [stdArr, setStdArr] = useState([]);
  const [secArr, setSecArr] = useState([]);
  const [monthName, setMonthName] = useState([]);
  const [teacherListPopup, setTeacherListPopup] = useState(false);
  const [viewAs, setViewAs] = useState(localStorage.getItem("viewAs") || "");
  const [timeTableSessionStartDate, setTimeTableSessionStartDate] =
    useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [events, setEvents] = useState([]);

  const [adjustedTime, setAdjustedTime] = useState("06:00");

  const [stdSelection, setStdSelection] = useState(
    localStorage.getItem("stdSelection") || "",
  );
  const [secSelection, setSecSelection] = useState(
    localStorage.getItem("secSelection") || "",
  );
  const [firstdayDefault, setFirstdayDefault] = useState(null);
  const [lastdayDefault, setLastdayDefault] = useState(null);
  const [isCreateLinkClicked, setIsCreateLinkClicked] = useState(false);

  const navigate = useNavigate();

  const jsonRole_CTinformation = useMemo(() => {
    const CTRole_Information = localStorage.getItem("role_as_class_teacher");
    return CTRole_Information ? JSON.parse(CTRole_Information) : [];
  }, []);

  const jsonRole_Coinformation = useMemo(() => {
    const CoRole_Information = localStorage.getItem("role_as_co_ordinator");
    return CoRole_Information ? JSON.parse(CoRole_Information) : [];
  }, []);

  const jsonRole_Geinformation = useMemo(() => {
    const general_role = localStorage.getItem("general_role");
    return general_role ? JSON.parse(general_role) : [];
  }, []);

  function parseISODate(isoString) {
    // agar null ya invalid mila
    if (!isoString) return null;

    // ISO string ko Date object mein convert karo
    const date = new Date(isoString);

    // agar invalid date mila toh null return karo
    if (isNaN(date.getTime())) {
      return null;
    }

    return date;
  }

  useEffect(() => {
    const saved = localStorage.getItem("liveSession");

    if (saved) {
      try {
        const parsed = JSON.parse(saved);

        if (parsed?.StartTime) {
          const convertedDate = parseISODate(parsed.StartTime);
          setSelectedDate(convertedDate);
        }
      } catch (err) {
        console.error("JSON parse error ❌", err);
      }
    } else {
      setSelectedDate(new Date());
    }
  }, []);

  useEffect(() => {
    let arr = [];
    if (viewAs !== "option1") {
      setStdArr([]);
      setSecArr([]);
    }

    // Check if 'viewAs' is selected
    if (viewAs === "option1") {
      // setStdSelection("");
      setEvents([]);
      jsonRole_CTinformation.forEach((item) => {
        if (item.is_class_teacher === true) {
          const idExists = arr.some((obj) => obj["id"] === item.standard_id.id);
          if (!idExists) {
            arr.push({
              id: item.standard_id.id,
              name: item.standard_id.name,
            });
          }
        }
      });
      setStdArr(arr);
    } else if (viewAs === "option2") {
      // setStdSelection("");
      setEvents([]);
      jsonRole_Coinformation.forEach((item) => {
        if (item.is_class_co_ordinator === true) {
          const idExists = arr.some((obj) => obj["id"] === item.standard_id.id);
          if (!idExists) {
            arr.push({
              id: item.standard_id.id,
              name: item.standard_id.name,
            });
          }
        }
      });
      setStdArr(arr);
    } else if (viewAs === "option3") {
      // setStdSelection("");

      setEvents([]);
      jsonRole_Geinformation.forEach((item) => {
        if (
          (item.is_class_co_ordinator === false &&
            item.is_class_teacher === false) ||
          !item.is_class_co_ordinator ||
          !item.is_class_co_ordinator
        ) {
          const idExists = arr.some((obj) => obj["id"] === item.standard_id.id);
          if (!idExists) {
            arr.push({
              id: item.standard_id.id,
              name: item.standard_id.name,
            });
          }
        }
      });
      setStdArr(arr);
    } else {
      setEvents([]);
      localStorage.removeItem("stdSelection");
      localStorage.removeItem("secSelection");
    }
  }, [
    viewAs,
    jsonRole_CTinformation,
    jsonRole_Coinformation,
    jsonRole_Geinformation,
  ]);

  useEffect(() => {
    let arr1 = [];
    setSecArr([]);
    if (viewAs === "option1") {
      // setSecSelection("");
      jsonRole_CTinformation.forEach((item) => {
        if (item.standard_id.id === stdSelection) {
          arr1.push({
            id: item.section_id.id,
            name: item.section_id.name,
          });
        }
      });
      setSecArr(arr1);
    } else if (viewAs === "option2") {
      // setSecSelection("");
      jsonRole_Coinformation.forEach((item) => {
        if (item.standard_id.id === stdSelection) {
          arr1.push({
            id: item.section_id.id,
            name: item.section_id.name,
          });
        }
      });
      setSecArr(arr1);
    } else if (viewAs === "option3") {
      // setSecSelection("");
      jsonRole_Geinformation.forEach((item) => {
        if (item.standard_id.id === stdSelection) {
          arr1.push({
            id: item.section_id.id,
            name: item.section_id.name,
          });
        }
      });
      setSecArr(arr1);
    } else if (viewAs === "option4") {
      setEvents([]);
    } else {
      setSecSelection("");
      localStorage.removeItem("secSelection");
    }
    // setSecArr([]);
  }, [stdSelection]);

  const handelDateChangeDefault = () => {
    if (!selectedDate) return;

    let baseDate = selectedDate && new Date(selectedDate);
    let dayOfWeek = baseDate.getDay();

    let firstDay = new Date(baseDate);
    firstDay.setDate(baseDate.getDate() - dayOfWeek);

    let lastDay = new Date(baseDate);
    lastDay.setDate(baseDate.getDate() + (6 - dayOfWeek));

    setFirstdayDefault(firstDay);
    setLastdayDefault(lastDay);
  };

  useEffect(() => {
    handelDateChangeDefault();
  }, [selectedDate]);

  //New UI implementation logic
  const scheduleRef = useRef(null);

  const closePopup = () => {
    if (scheduleRef && scheduleRef.current) {
      scheduleRef.current.closeQuickInfoPopup();
    }
  };

  const closeTimeTablePopup = async () => {
    closePopup();
    setIsCreateLinkClicked(false);
  };

  const dayEventTemplate = (props) => {
    return (
      <TimeTableDayEvent
        event={props}
        refetch={handleDataPopulate}
        SDate={firstdayDefault}
        EDate={lastdayDefault}
        refresh={closeTimeTablePopup}
        setIsCreateLinkClicked={setIsCreateLinkClicked}
      />
    );
  };

  const weekEventTemplate = (props) => {
    return (
      <TimeTableWeekEvent
        event={props}
        refetch={handleDataPopulate}
        SDate={firstdayDefault}
        EDate={lastdayDefault}
        refresh={closeTimeTablePopup}
        setIsCreateLinkClicked={setIsCreateLinkClicked}
      />
    );
  };

  const onEventRendered = (args) => {
    const currentTime = new Date();
    const isHappened = currentTime.getTime() > args.data?.EndTime?.getTime();

    // Base color coming from data
    let displayColor = args.data.DisplayColor || "#3B82F6";

    // ✅ Replace too-light default color with dark blue
    if (displayColor.toUpperCase() === "#DFF7F9") {
      displayColor = "#0D47A1";
    }

    if (isHappened && args.data.LactureType !== "general_lacture") {
      args.element.style.backgroundColor = displayColor;
      args.element.style.opacity = 0.5;
    } else if (
      args.data.LactureType === "general_lacture" ||
      args.data.LectureName === "Assembly"
    ) {
      args.element.style.backgroundColor = "#E5E7EB";
    } else {
      args.element.style.backgroundColor = displayColor;
    }
  };

  const onActionBegin = (args) => {
    if (args.requestType === "toolbarItemRendering") {
      args.items = args.items.slice(3);
    }
    if (args?.event?.target?.innerText === "TODAY") {
      setSelectedDate(new Date());
    }
  };

  const header = (props) => {
    // Implementation for headerTemplate
    const currentTime = new Date();
    const isHappened = currentTime.getTime() > props?.EndTime?.getTime();
    return props.LactureType !== "general_lacture" ? (
      <div className="quick-info-header">
        <div className="quick-info-header-content">
          <div
            className="heder_template"
            style={{ background: isHappened ? "#808080" : props?.DisplayColor }}
          ></div>
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const onPopupClose = (args) => {};

  const onPopupOpen = (args) => {
    try {
      if (args === "close") {
        onPopupClose(args);
      }

      if (isCreateLinkClicked && args.type === "QuickInfo") {
        args.cancel = true;

        setTimeout(() => {
          setIsCreateLinkClicked(false);
        }, 300);

        return;
      }
      if (args.type === "Editor" || args.type === "RecurrenceAlert") {
        args.cancel = true;
      }

      if (args.type === "QuickInfo") {
        const { data } = args;

        if (!data?.Id || data?.LactureType === "general_lacture") {
          args.cancel = true;
          return;
        }

        // Wait for popup to render
        setTimeout(() => {
          const popup = args.element;
          if (popup) {
            popup.style.width = "420px";
            popup.style.maxHeight = "none";
            popup.style.overflow = "visible";
            popup.style.top = "20px";
            popup.style.transform = "translateY(-10px)";
            popup.style.zIndex = "9999"; // ensure it's above other UI
          }
        }, 10);
      }
    } catch (error) {
      console.log("PopupOpen Error:", error);
    }
  };

  const contentTemplate = (props) => {
    if (props.LactureType === "general_lacture") {
      return null; // bilkul kuch render mat karo
    }

    if (props?.elementType === "cell") {
      return null; // empty cell pe bhi kuch mat dikhao
    }

    return (
      <SummaryLectureUi
        event={props}
        scheduleRef={scheduleRef}
        refetch={handleDataPopulate}
        SDate={firstdayDefault}
        EDate={lastdayDefault}
        setIsCreateLinkClicked={setIsCreateLinkClicked}
      />
    );
  };

  const onDragStart = (args) => {
    args.cancel = true;
  };

  const onResizeStart = (args) => {
    args.cancel = true;
  };

  useEffect(() => {
    const fetchTimeTableSessionData = async () => {
      if (!academicYearId) return;
      try {
        const res = await axios.get(
          `/api/v1/school/schoolSession/get/academicYear/${academicYearId}`,
        );

        const filteredData = res?.data?.data?.filter(
          (item) => item.timeTableSession._id === timetableSessionId,
        );

        if (filteredData && filteredData.length > 0) {
          setTimeTableSessionStartDate(filteredData[0].start_time);
        } else {
          console.warn("No matching time table session found");
          setTimeTableSessionStartDate(null); // or handle accordingly
        }
      } catch (err) {
        console.error("Error fetching timetable session data:", err);
      }
    };

    fetchTimeTableSessionData();
  }, [academicYearId, timetableSessionId]);

  useEffect(() => {
    if (
      !timeTableSessionStartDate ||
      typeof timeTableSessionStartDate !== "string"
    )
      return;

    // Optional: Make sure the format is HH:mm
    const timeParts = timeTableSessionStartDate.split(":");
    if (timeParts.length !== 2) return;

    const [hours, minutes] = timeParts.map(Number);

    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes - 30); // Subtract 30 minutes

    const newHours = String(date.getHours()).padStart(2, "0");
    const newMinutes = String(date.getMinutes()).padStart(2, "0");

    setAdjustedTime(`${newHours}:${newMinutes}`);
  }, [timeTableSessionStartDate]);

  const helper2 = (item, startday, finalStartDay, finalendDay) => {
    start_time1 = formatTime(item.start_time);
    end_time1 = formatTime(item.end_time);
    function formatTime(time) {
      var timeString = time.toString();
      while (timeString.length < 4) {
        timeString = "0" + timeString;
      }
      return timeString.slice(0, 2) + ":" + timeString.slice(2, 4) + ":00";
    }
    const resTimeManageStart = () => {
      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
        All: 8,
      };
      let dayNo = dayMap[item.day];
      // Convert the start and end dates to UTC timestamps
      const startTimestamp = finalStartDay.getTime();
      const endTimestamp = finalendDay.getTime();
      // Loop through all dates between the start and end dates
      for (
        let timestamp = startTimestamp;
        timestamp <= endTimestamp;
        timestamp += 24 * 60 * 60 * 1000
      ) {
        date = new Date(timestamp);
        // Check if the date matches the desired day of the week
        if (date.getDay() === dayNo) {
          const dateString = date;
          const date1 = new Date(dateString);
          let formattedDate = date1.toDateString();
          formattedDate = formattedDate.concat(
            ` ${start_time1} GMT+0530 (India Standard Time)`,
          );
          return formattedDate;
        }
      }
      // If no matching date was found, return null
      return null;
    };
    const resTimeManageEnd = () => {
      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
        All: 8,
      };
      let dayNo = dayMap[item.day];
      // Convert the start and end dates to UTC timestamps
      const startTimestamp = finalStartDay.getTime();
      const endTimestamp = finalendDay.getTime();
      // Loop through all dates between the start and end dates
      for (
        let timestamp = startTimestamp;
        timestamp <= endTimestamp;
        timestamp += 24 * 60 * 60 * 1000
      ) {
        date = new Date(timestamp);
        // Check if the date matches the desired day of the week
        if (date.getDay() === dayNo) {
          const dateString = date;
          const date1 = new Date(dateString);
          let formattedDate = date1.toDateString();
          formattedDate = formattedDate.concat(
            ` ${end_time1} GMT+0530 (India Standard Time)`,
          );
          return formattedDate;
        }
      }
      return null;
    };
    const timeForAll = () => {
      let inputDate = startday;
      let date = new Date(inputDate);
      let year = date.getUTCFullYear();
      let month = String(date.getUTCMonth() + 1).padStart(2, "0");
      let day = String(date.getUTCDate()).padStart(2, "0");
      let formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    };
    const helper3 = (supplements) => {
      if (item.name === "general_lacture") {
      }
      response2 = [];
      response1 = [];
      const filtered = Object.entries(supplements || {})
        .filter(([key, value]) => value !== null)
        .reduce((obj, [key, value]) => {
          if (obj === undefined) {
            return undefined;
          }
          if (obj === null) {
            return null;
          }
          obj[key] = value;
          delete obj.id;
          return obj;
        }, {});
      // if (
      //   filtered.pre_read ||
      //   filtered.activity ||
      //   filtered.homework ||
      //   filtered.assessment ||
      //   filtered.bbb_lecture
      // ) {
      response1.push(filtered);
      // }
      response1.forEach((i) => {
        response2 = helper4(i);
      });
      return response2;
    };
    let res1 = {
      Id: item.id,
      LectureName: item?.name,
      Subject: item?.subject?.name ? item?.subject?.name : item?.name,
      Subject_id: item?.subject?.id,
      StartTime: new Date(
        `${
          item.day === "All"
            ? `${timeForAll()}T${start_time1}`
            : resTimeManageStart()
        }`,
      ),
      EndTime: new Date(
        `${
          item.day === "All"
            ? `${timeForAll()}T${end_time1}`
            : resTimeManageEnd()
        }`,
      ),
      IsAllDay: false,
      Events: helper3(item.supplements),
      Supplement_id: item?.supplements?.id,
      Teacher: item?.teacher?.id,
      TeacherName: item?.teacher?.name,
      LactureType: item?.lactureType,
      DisplayColor: `#${item?.subject?.color}`,
      // lectureCategory: ,
      RecurrenceRule: `FREQ=${
        item.day === "All" ? "DAILY" : "WEEKLY"
      };INTERVAL=1;`,
    };
    return res1;
  };

  const dateFormatToGetdate = (date) => {
    const startdate = new Date(date);
    const outputDate = startdate.toUTCString().replace(",", "");
    let outputDate1 = outputDate.concat("+0530");
    return outputDate1;
  };

  useEffect(() => {
    const savedViewAs = localStorage.getItem("viewAs");
    const savedStd = localStorage.getItem("stdSelection");
    const savedSec = localStorage.getItem("secSelection");

    if (savedViewAs) {
      setViewAs(savedViewAs);
    }

    if (savedStd) {
      setStdSelection(savedStd);
    }

    if (savedSec) {
      setSecSelection(savedSec);
    }
  }, []);
  const handleDataPopulate = async (
    standardId,
    sectionId,
    startDate,
    endDate,
  ) => {
    try {
      setEvents([]);

      if (!startDate || !endDate) return;

      let res = [];

      // ✅ MY LECTURE FLOW
      if (viewAs === "option4") {
        const teacherId = JSON.parse(localStorage.getItem("Teacher_id"));
        const schoolId = JSON.parse(localStorage.getItem("schoolId"));

        startday1 = dateFormatToGetdate(startDate);
        endday1 = dateFormatToGetdate(endDate);
        let finalStartDay = new Date(startday1);
        let finalendDay = new Date(endday1);

        const formatDate = (date) => {
          const d = new Date(date);
          return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
            2,
            "0",
          )}-${String(d.getDate()).padStart(2, "0")}`;
        };

        const start = formatDate(startDate);
        const end = formatDate(endDate);

        const response = await axios.get(
          `/api/v1/timetableforTeacher/get/schoolId/${schoolId}/teacherId/${teacherId}/startDate/${start}/endDate/${end}?academic_year_id=${academicYearId}&timetable_session_id=${timetableSessionId}`,
        );

        const data = response.data.data || [];

        for (let i = 0; i < data.length; i++) {
          const schedules = data[i].schedules || [];

          for (let j = 0; j < schedules.length; j++) {
            const schedule = schedules[j];

            for (let k = 0; k < schedule.special_lectures.length; k++) {
              schedule.special_lectures[k].lactureType = "special_lacture";
              response6.push(schedule.special_lectures[k]);
            }

            for (let k = 0; k < schedule.lectures.length; k++) {
              schedule.lectures[k].lactureType = "lacture";
              response6.push(schedule.lectures[k]);
            }

            for (let k = 0; k < schedule.general_categories.length; k++) {
              schedule.general_categories[k].lactureType = "general_lacture";
              response6.push(schedule.general_categories[k]);
            }
          }
        }
        response6.forEach((i) => {
          res.push(helper2(i, startDate, finalStartDay, finalendDay));
        });
      }

      // ✅ NORMAL FLOW
      else {
        if (!standardId || !sectionId) return;

        res = await getTimeTable(standardId, sectionId, startDate, endDate);
      }

      setEvents(Array.isArray(res) ? res : []);

      // month label logic (same as yours)
      const formatDateRange = (startDate, endDate) => {
        if (!startDate || !endDate) return "";
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

        const start = new Date(startDate);
        const end = new Date(endDate);

        if (
          start.getMonth() === end.getMonth() &&
          start.getFullYear() === end.getFullYear()
        ) {
          return `${monthNames[start.getMonth()]} ${start.getDate()} - ${end.getDate()}, ${start.getFullYear()}`;
        }

        return `${monthNames[start.getMonth()]} ${start.getDate()} - ${monthNames[end.getMonth()]} ${end.getDate()}, ${end.getFullYear()}`;
      };

      setMonthName(formatDateRange(startDate, endDate));
    } catch (error) {
      console.error("Error fetching timetable:", error);
      setEvents([]);
      setMonthName("");
    }
  };

  useEffect(() => {
    localStorage.setItem("viewAs", viewAs);
    localStorage.setItem("stdSelection", stdSelection);
    localStorage.setItem("secSelection", secSelection);

    if (
      firstdayDefault &&
      lastdayDefault &&
      (viewAs === "option4" || (stdSelection && secSelection))
    ) {
      handleDataPopulate(
        stdSelection,
        secSelection,
        firstdayDefault,
        lastdayDefault,
      );
    }
  }, [viewAs, stdSelection, secSelection, firstdayDefault, lastdayDefault]);

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate?.value);
    var curr = newDate?.value;
    const firstday = startOfWeek(curr);
    const lastday = endOfWeek(curr);
    // scheduleRef.refresh();
    handleDataPopulate(stdSelection, secSelection, firstday, lastday);
    localStorage.removeItem("liveSession");
  };

  const smoothScrollTo = (element, to, duration = 500) => {
    const start = element.scrollTop;
    const change = to - start;
    const startTime = performance.now();

    const animateScroll = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // easeInOut
      const ease =
        progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;

      element.scrollTop = start + change * ease;

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  };

  useEffect(() => {
    if (!scheduleRef.current || events.length === 0) return;

    // 🔒 Get selected date from schedule
    const selectedDate = scheduleRef.current.selectedDate;
    if (!selectedDate) return;

    const today = new Date();

    // 🔥 DATE MATCH CHECK (ONLY TODAY)
    const isToday =
      selectedDate.getDate() === today.getDate() &&
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getFullYear() === today.getFullYear();

    if (!isToday) return; // ❌ NOT TODAY → DO NOTHING

    // ✅ TODAY ONLY LOGIC
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    setTimeout(() => {
      // 1️⃣ Hidden jump
      scheduleRef.current.scrollTo(`${hours}:${minutes}`);

      // 2️⃣ Scroll container
      const content = document.querySelector(".e-content-wrap");
      if (!content) return;

      // 3️⃣ Center scroll
      const targetScroll = content.scrollTop - content.clientHeight / 2;

      // 4️⃣ Smooth animation
      smoothScrollTo(content, targetScroll, 600);
    }, 300);
  }, [events]);

  const IsDisabledManage =
    viewAs === "option3" || !stdSelection || !secSelection;

  return (
    <div
      className={`${
        leftSidebarSize === 70 ? "expand" : "collapsess"
      } orange-scrollBar`}
      style={{ maxHeight: "100vh", overflowY: "scroll" }}
    >
      {/* main content */}
      <div
        className="rounded-2 p-2"
        style={{
          backgroundColor: "white",
          maxHeight: "600px",
          overflowY: "scroll",
        }}
      >
        <h6 className="px-2 text-muted">
          Please select fields below to view Lecture
        </h6>

        {/* header with slect and Date */}
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2  mt-2">
          <div className="d-flex gap-2 align-items-center flex-row flex-wrap col-6">
            <SubStdSelContext.Consumer>
              {({
                secSelectedOption,
                setSecSelectedOption,
                stdSelectedOption,
                setStdSelectedOption,
                setTeacherDCM,
                setSecSelectedOptionName,
                setStdSelectedOptionName,
              }) => (
                <div
                  className="d-flex align-items-center gap-2 "
                  style={{ width: "100%" }}
                >
                  <FormControl
                    fullWidth
                    variant="outlined"
                    size="small"
                    sx={{ mr: 2 }}
                  >
                    <InputLabel id="view-as-label">View As</InputLabel>
                    <Select
                      labelId="view-as-label"
                      id="view-as-label"
                      label="View As"
                      value={viewAs}
                      onChange={(e) => {
                        setViewAs(e.target.value);
                        setTeacherDCM(e.target.value);
                        localStorage.setItem("stdSelection", "");
                        localStorage.setItem("secSelection", "");
                        setStdSelection("");
                        setSecSelection("");
                        setEvents([]);
                      }}
                      renderValue={(selected) => {
                        return selected === "option1"
                          ? "Class Teacher"
                          : selected === "option2"
                            ? "Coordinator"
                            : selected === "option3"
                              ? "General Teacher"
                              : selected === "option4"
                                ? "My Lecture"
                                : "";
                      }}
                    >
                      {jsonRole_CTinformation?.length > 0 && (
                        <MenuItem value="option1">Class Teacher</MenuItem>
                      )}
                      {jsonRole_Coinformation?.length > 0 && (
                        <MenuItem value="option2">Coordinator</MenuItem>
                      )}
                      {jsonRole_Geinformation?.length > 0 && (
                        <MenuItem value="option3">General Teacher</MenuItem>
                      )}
                      <MenuItem value="option4">My Lecture</MenuItem>
                    </Select>
                  </FormControl>

                  {/* Standard */}
                  <FormControl
                    fullWidth
                    variant="outlined"
                    size="small"
                    sx={{ mr: 2 }}
                  >
                    <InputLabel id="standard-label">Standard</InputLabel>
                    <Select
                      labelId="standard-label"
                      label="Standard"
                      id="standard-label"
                      value={stdSelection}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selectedObj = stdArr.find(
                          (item) => item.id === selectedId,
                        );

                        const selectedName = selectedObj?.name || "";
                        setStdSelectedOptionName(selectedName);
                        setStdSelection(selectedId);
                        setStdSelectedOption(selectedId);
                        setSecSelection("");
                        localStorage.setItem("stdSelection", "");
                        localStorage.setItem("secSelection", "");
                        localStorage.setItem("stdSelectionName", selectedName);
                        setEvents([]);
                      }}
                    >
                      {stdArr?.length > 0 &&
                        [...stdArr]
                          .sort((a, b) => {
                            const aNum = Number(a.name);
                            const bNum = Number(b.name);

                            if (!isNaN(aNum) && !isNaN(bNum)) {
                              return aNum - bNum;
                            }
                            return a.name.localeCompare(b.name);
                          })
                          .map((standard) => (
                            <MenuItem key={standard.id} value={standard.id}>
                              {standard.name}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>

                  {/* Section */}
                  <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel id="section-label">Section</InputLabel>
                    <Select
                      label="Section"
                      labelId="section-label"
                      id="section-label"
                      value={secSelection}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selectedObj = secArr.find(
                          (item) => item.id === selectedId,
                        );
                        const selectedName = selectedObj?.name || "";

                        setSecSelectedOptionName(selectedName);
                        setSecSelection(selectedId);
                        setSecSelectedOption(selectedId);
                        setSelectedDate(new Date());
                        localStorage.setItem("secSelectionName", selectedName);
                      }}
                    >
                      {secArr?.length > 0 &&
                        [
                          ...new Map(
                            secArr.map((section) => [section?.id, section]),
                          ).values(),
                        ].map((section) => (
                          <MenuItem key={section?.id} value={section?.id}>
                            {section?.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>
              )}
            </SubStdSelContext.Consumer>
          </div>
          <div
            className="list_holiday"
            onClick={() => setTeacherListPopup(true)}
          >
            List of Teachers
          </div>
        </div>

        <div
          className={`d-flex align-items-center mt-2 ${
            selectedDate && secSelection
              ? " justify-content-between "
              : " justify-content-end "
          }`}
        >
          {selectedDate && secSelection && (
            <Box
              sx={{
                px: 3, // horizontal padding
                py: 1.5, // vertical padding
                borderRadius: 1,

                display: "inline-block",

                minWidth: 120,
                textAlign: "center",
              }}
            >
              {monthName && (
                <div className="d-flex align-items-center gap-2">
                  <CalendarTodayIcon sx={{ color: "#0d47a1" }} />
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      color: "#0d47a1", // dark blue text
                    }}
                  >
                    {monthName}
                  </Typography>
                </div>
              )}
            </Box>
          )}

          <div className="d-flex gap-2 align-items-center justify-content-end col-5">
            <Button
              variant="contained"
              disabled={IsDisabledManage}
              onClick={() => navigate("/createTimeTableManually/true")}
              sx={{
                backgroundColor: "#FF9800", // orange
                color: "#fff", // white text
                "&:hover": {
                  backgroundColor: "#fb8c00", // slightly darker orange on hover
                },
              }}
            >
              Manage Timetable
            </Button>

            {/* Select Specific Date */}
            <div style={{ width: "200px" }}>
              <DatePickerComponent
                placeholder="Select Specific Date"
                value={selectedDate || null}
                format="dd-MMM-yyyy"
                onChange={handleDateChange}
                floatLabelType="Never"
                cssClass="e-outline"
              />
            </div>
          </div>
        </div>

        {/* List of Teachers */}
        {teacherListPopup && (
          <ListOfTeachersPop
            setTeacherListPopup={setTeacherListPopup}
            teacherListPopup={teacherListPopup}
          />
        )}

        {/* main container with Calendar of sync fusion */}

        <div className="mt-1">
          <div>
            <ScheduleComponent
              // key={events.length}
              ref={scheduleRef}
              //fix calender scroll issue

              cssClass="schedule-overview"
              height="490px"
              selectedDate={selectedDate}
              currentView="Week"
              startHour="6:00"
              endHour="23:59"
              // allowDragAndDrop={editClick}
              allowDragAndDrop={false}
              eventRendered={onEventRendered}
              actionBegin={onActionBegin}
              eventSettings={{ dataSource: [...events] }}
              // actionComplete={onActionComplete}
              // onCellDoubleClick={onCellDoubleClick}
              quickInfoTemplates={{
                header: header,
                content: contentTemplate,
              }}
              timeScale={{
                enable: true,
                interval: 30,
                slotCount: 1,
              }}
              // created={onCreated}
              // editorTemplate={editorTemplate}
              popupOpen={onPopupOpen}
              popupClose={onPopupClose}
              cellClick={null}
              dragStart={onDragStart}
              resizeStart={onResizeStart}
            >
              <ViewsDirective>
                <ViewDirective
                  option="Day"
                  eventTemplate={dayEventTemplate}
                  popupOpen={onPopupOpen}
                />
                <ViewDirective
                  option="Week"
                  eventTemplate={weekEventTemplate}
                />
              </ViewsDirective>

              <Inject services={[Day, Week, Resize]} />
            </ScheduleComponent>

            <style>
              {`
  /* Increase row height */
  .e-schedule .e-time-cells-wrap table td,
  .e-schedule .e-work-cells {
    height: 60px !important;
  }
    .e-toolbar-items .e-custom-month-label {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #333 !important;
  pointer-events: none;
  margin: 0 10px;
}


  /* Time slot labels (left side) */
  .e-schedule .e-time-cells {
    font-weight: 600 !important;
    font-size: 14px !important;
    background-color: #fff0c5 !important;
    color: #333 !important;
  }

  /* Header cells (day slots like Sun, Mon...) */
  .e-schedule .e-header-cells {
    font-weight: bold !important;
    font-size: 14px !important;
    background-color: #fff0c5 !important;
    border-right: 1px solid #eee !important;
    text-align: center !important;
    vertical-align: middle !important;
  }

    .e-schedule {
    border: 1px solid #d3d3d3  !important; /* dark gray border */
    border-radius: 4px !important;
  }

  /* Day number and text */
  .e-schedule .e-header-day,
  .e-schedule .e-header-date {
    font-size: 14px !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
    display: block !important;
  }

  .e-schedule .e-header-day {
    font-size: 16px !important;
    font-weight: 700 !important;
  }

  /* Calendar background */
  .e-schedule .e-table {
    background-color: #fffdf5 !important;
  }

  /* Cell border */
  .e-schedule .e-work-cells {
    border: 1px solid #f0e6cc !important;
  }


  /* Week/Month toggle buttons */
  .e-schedule .e-toolbar-items .e-tbar-btn {
    border-radius: 4px !important;
    font-weight: 600 !important;
    color: #333 !important;
  }

  .e-schedule .e-toolbar-items .e-tbar-btn.e-active {
    background-color: #f57c00 !important;
    color: white !important;
  }
    /* Enable vertical scrolling */
.e-schedule .e-content-wrap {
  overflow-y: auto !important;
}

/* Chrome / Edge / Brave */
.e-schedule .e-content-wrap::-webkit-scrollbar {
  width: 8px;
}

.e-schedule .e-content-wrap::-webkit-scrollbar-track {
  background: #f5f5f5;
}

.e-schedule .e-content-wrap::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 4px;
}

.e-schedule .e-content-wrap::-webkit-scrollbar-thumb:hover {
  background-color: #9e9e9e;
}

/* Firefox */
.e-schedule .e-content-wrap {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f5f5f5;
}

`}
            </style>
          </div>
        </div>
      </div>
    </div>
  );
}
